module.exports = "<div ui-view>\n    <fizy-paycell-no-auth-buy-invalid ng-if=\"$ctrl.isPaycellPackage() && !$ctrl.valid\" msisdn=\"$ctrl.msisdn\" valid=\"$ctrl.valid\"\n        packet=\"$ctrl.packet\"></fizy-paycell-no-auth-buy-invalid>\n    <fizy-paycell-no-auth-buy-valid ng-if=\"$ctrl.isPaycellPackage() && !!$ctrl.valid\" msisdn=\"$ctrl.msisdn\" valid=\"$ctrl.valid\"\n        packet=\"$ctrl.packet\"></fizy-paycell-no-auth-buy-valid>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/no-auth/buy/buy.html
// module id = 429
// module chunks = 0